
export default function ContactDetailsSection() {
  return (
    <section className="py-12 sm:py-20 bg-dark-900">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-white mb-3 sm:mb-4 px-2">
              Multiple Ways to <span className="text-red-500">Connect</span>
            </h2>
            <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto px-4 sm:px-0">
              Choose the method that works best for you. I'm committed to responding quickly 
              and providing the personalized attention you deserve.
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
            {/* Phone */}
            <div className="text-center bg-dark-800 border border-dark-700 rounded-xl p-6 sm:p-8 hover:bg-dark-700 transition-colors duration-300">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className="ri-phone-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">Call or Text</h3>
              <div className="space-y-1 sm:space-y-2">
                <a href="tel:5196583026" className="block text-red-500 font-semibold text-base sm:text-lg hover:text-red-400 transition-colors">
                  (519) 658-3026
                </a>
                <p className="text-gray-300 text-xs sm:text-sm">
                  Available Mon-Fri<br />
                  9:00 AM - 7:00 PM EST
                </p>
                <p className="text-gray-400 text-xs">
                  Emergency consultations available by appointment
                </p>
              </div>
            </div>
            
            {/* Email */}
            <div className="text-center bg-dark-800 border border-dark-700 rounded-xl p-6 sm:p-8 hover:bg-dark-700 transition-colors duration-300">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className="ri-mail-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">Email</h3>
              <div className="space-y-1 sm:space-y-2">
                <a href="mailto:tmonteiro@mortgagealliance.com" className="block text-red-500 font-semibold hover:text-red-400 transition-colors text-xs sm:text-sm break-all px-2 sm:px-0">
                  tmonteiro@mortgagealliance.com
                </a>
                <p className="text-gray-300 text-xs sm:text-sm">
                  Response within 4 hours<br />
                  during business days
                </p>
                <p className="text-gray-400 text-xs">
                  Secure document sharing available
                </p>
              </div>
            </div>
            
            {/* Office */}
            <div className="text-center bg-dark-800 border border-dark-700 rounded-xl p-6 sm:p-8 hover:bg-dark-700 transition-colors duration-300 sm:col-span-2 md:col-span-1">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className="ri-map-pin-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-white mb-3 sm:mb-4">Office</h3>
              <div className="space-y-1 sm:space-y-2">
                <p className="text-gray-300 text-xs sm:text-sm">
                  Serving all of Ontario<br />
                  Based in London, ON
                </p>
                <p className="text-gray-300 text-xs sm:text-sm">
                  In-person meetings<br />
                  available by appointment
                </p>
                <p className="text-gray-400 text-xs">
                  Virtual consultations preferred
                </p>
              </div>
            </div>
          </div>
          
          {/* FAQ Section */}
          <div className="bg-dark-800 border border-dark-700 rounded-2xl p-6 sm:p-8">
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-6 sm:mb-8 text-center px-2">
              Common Questions About <span className="text-red-500">Getting Started</span>
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
              <div className="space-y-4 sm:space-y-6">
                <div>
                  <h4 className="font-bold text-base sm:text-lg text-white mb-1 sm:mb-2">How quickly can we start?</h4>
                  <p className="text-gray-300 text-xs sm:text-sm">
                    Usually within 24 hours. I'll review your situation and provide initial guidance 
                    on our first call, then we can move forward immediately if you're ready.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-bold text-base sm:text-lg text-white mb-1 sm:mb-2">What information should I prepare?</h4>
                  <p className="text-gray-300 text-xs sm:text-sm">
                    Basic income information, property details (if applicable), and your current 
                    mortgage situation. I'll guide you through exactly what's needed.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-bold text-base sm:text-lg text-white mb-1 sm:mb-2">Do you charge consultation fees?</h4>
                  <p className="text-gray-300 text-xs sm:text-sm">
                    No. Initial consultations are always free. My compensation comes from successful 
                    mortgage completions, so I'm motivated to find you the best solution.
                  </p>
                </div>
              </div>
              
              <div className="space-y-4 sm:space-y-6">
                <div>
                  <h4 className="font-bold text-base sm:text-lg text-white mb-1 sm:mb-2">Can you help with difficult cases?</h4>
                  <p className="text-gray-300 text-xs sm:text-sm">
                    Absolutely. Self-employed, new to Canada, credit challenges, or unique properties - 
                    I specialize in finding solutions when traditional lenders say no.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-bold text-base sm:text-lg text-white mb-1 sm:mb-2">What's your service area?</h4>
                  <p className="text-gray-300 text-xs sm:text-sm">
                    I serve all of Ontario with virtual consultations and document processing. 
                    In-person meetings available in the London area by appointment.
                  </p>
                </div>
                
                <div>
                  <h4 className="font-bold text-base sm:text-lg text-white mb-1 sm:mb-2">How long does the process take?</h4>
                  <p className="text-gray-300 text-xs sm:text-sm">
                    Varies by complexity, but typically 2-4 weeks for conventional mortgages. 
                    Private lending can be faster - sometimes within days for urgent situations.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
